// extracted by mini-css-extract-plugin
export default {"formHeading":"oM-z","form":"pM-z","submitBtn":"qM-z","disabled":"rM-z","input":"sM-z","error":"tM-z","submitMsg":"uM-z","signIn":"vM-z"};